import React from 'react';
import { reduxForm } from 'redux-form';

import FinishJobFormStep1 from './FinishJobFormStep1';
import FinishJobFormStep2 from './FinishJobFormStep2';
import { CSSTransitionGroup } from 'react-transition-group';

let FinishPauseJobForm = props => {
  const { stepOne, stepTwo, enableSignButton, pauseJob } = props;

  return (
    <div className="row">
      <CSSTransitionGroup
        transitionName="fade_out_buttons"
        transitionEnterTimeout={200}
        transitionLeaveTimeout={200}
      >
        {stepOne && <FinishJobFormStep1 pauseJob={pauseJob} />}
        {stepTwo && <FinishJobFormStep2 enableSignButton={enableSignButton} />}
      </CSSTransitionGroup>
    </div>
  );
};

FinishPauseJobForm = reduxForm({
  form: 'update_status_maintenance_form',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(FinishPauseJobForm);

export default FinishPauseJobForm;
